<template>
    <div class="card card-info">
        <div class="card-header">
            <h3 class="card-title">Job  Applications</h3>
        </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <label>Jobs Campaign *</label>
                    <select class="form-control" v-model="filter.JobCampaignID" v-on:change="loadJobsOffered">
                        <option value="">--Select--</option>
                        <option v-for="item in jobCampaigns" v-bind:value="item.JobCampaignID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Jobs Offered </label>
                    <select class="form-control" v-model="filter.JobOfferingID">
                        <option value="">--Select Job--</option>
                        <option v-for="item in jobsOffered" v-bind:value="item.JobOfferingID">{{item.JobTitle}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Gender </label>
                    <select class="form-control" v-model="filter.GenderID">
                        <option value="">--Select Gender--</option>
                        <option v-for="item in gender" v-bind:value="item.GenderID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Status</label>
                        <select class="form-control" v-model="filter.Status">
                            <option value="">All</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Pending">Pending</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <label>Application Status</label>
                    <select class="form-control" v-model="filter.ApplicationStatus">
                        <option value="All">--All--</option>
                        <option value="Completed">Completed</option>
                        <option value="InComplete">InComplete</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Name/Application No./Father Name/CNIC</label>
                    <input class="form-control" v-model="filter.Name" />
                </div>
                <div class="col-md-4">
                    <label>Period From</label>
                    <input class="form-control" type="date" v-model="filter.DateFrom" />
                </div>
                <div class="col-md-4">
                    <label>Period To</label>
                    <input class="form-control" type="date" v-model="filter.DateTo" />
                </div>
                <div class="col-md-4">
                    <label>Age From</label>
                    <input class="form-control" v-model="filter.AgeFrom" />
                </div>
                <div class="col-md-4">
                    <label>Age to</label>
                    <input class="form-control" v-model="filter.AgeTo" />
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Filter by Experience</label>
                        <select class="form-control" v-model="filter.ExperienceType">
                            <option value="Omit">Omit</option>
                            <option value="All">All</option>
                            <option value="Teaching">Teaching</option>
                            <option value="Industrial">Industrial</option>
                            <option value="Administration">Administration</option>
                            <option value="Professional">Professional</option>
                        </select>
                    </div>
                </div>

                <div class="col-md-2" v-if="filter.ExperienceType != 'Omit'">
                    <label>Min Years</label>
                    <input class="form-control" v-model="filter.Years" />
                </div>


                <div class="col-md-12">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="customCheckbox1" value="option1" v-model="filter.DisplayPicture">
                        <label for="customCheckbox1" class="custom-control-label">Display Record With Pictures (It may take some time)</label>
                    </div>
                </div>



                <div class="col-md-12">
                    <div class="form-group float-right">
                        <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Search</button>
                        <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="exportexcel()" v-if="exceldatastatus==='enabled'">Export All Data</button>
                    </div>
                </div>
            </div>

            <div class="row" style="margin-top: 10px" v-if="applicants.length > 0">
                <div class="col-md-12">
                    <hr />
                    <div class="table-responsive">
                        <table id="bs4-table" class="table table-striped table-color table-sm" style="font-size: 12px;">
                            <thead class="bg-info">
                                <tr>
                                    <th style="width: 5px; text-align: center">Sr.#</th>
                                    <th v-show="showImage" style="width: 20px; text-align: center">Image</th>
                                    <th style="width: 20%">Job Applied For</th>
                                    <th style="width: 15%">Application #</th>
                                    <th style="width: 20%">Name</th>
                                    <th style="width: 20%">Father Name</th>
                                    <th style="width: 10%">CNIC</th>
                                    <th style="width: 10%">Date Of Birth</th>
                                    <th style="width: 15%">City</th>
                                    <th style="width: 5px; text-align: center;">Status</th>
                                    <!--<th style="width: 50px; text-align: center;">Verification</th>-->
                                    <th style="width: 25px; text-align: center;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(p, ind) in applicants">
                                <td style="text-align: center; vertical-align: middle">{{ind + 1}}</td>
                                <td v-show="showImage" style="text-align: center; vertical-align: middle">
                                  <img style="max-height: 60px" v-bind:src="p.temp" />
                                </td>
                                <td style="vertical-align: middle">
                                  <span v-for="pr in p.JobTitles">
                                    {{pr.Name}}<br />
                                  </span>
                                </td>
                                <td style="vertical-align: middle">{{p.ApplicationNo}}</td>
                                <td style="vertical-align: middle">
                                  {{p.ApplicantName}}
                                </td>
                                <td style="vertical-align: middle">{{p.FatherName}}</td>
                                <td style="vertical-align: middle">{{p.CNIC}}</td>
                                <td style="vertical-align: middle">{{p.DateOfBirth}}</td>

                                <td style="vertical-align: middle">{{p.City}}</td>
                                <td style="vertical-align: middle; text-align: center;">
                                  <i v-if="p.IsApproved" style="color: #5cb85c">Approved</i>
                                  <i v-else style="color: #d9534f">Not Approved</i>
                                  <br />
                                  <i v-if="p.IsPost">Complete</i>
                                  <i v-else>InComplete</i>
                                  <i data-toggle="tooltip" title="Documents Attached" v-if="p.Attachment" class="fas fa-paperclip"></i>
                                </td> 
                                <td style="vertical-align: middle; text-align: center;">
                                  <div class="btn-group-vertical">
                                    <button type="button" class="btn btn-success" data-toggle="tooltip" title="Print CV From" v-on:click="printCV(p.ApplicantRegistrationID)"><i class="fas fa-print"></i></button>
                                    <button type="button" class="btn btn-info" data-toggle="tooltip" title="FollowUp" v-on:click="followup(p.ApplicantRegistrationID)"><i class="fas fa-phone"></i></button>
                                    <button class="btn btn-primary btn-sm" v-on:click="edit(p.ApplicantRegistrationID)"><i class="fas fa-edit"></i></button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>const axios = require('axios').default;

    export default ({
        data() {
            return {
                city: [],
                gender: [],
                jobCampaigns: [],
                jobsOffered: 0,
                filter: {
                    GenderID: '', CityID: '', ApplicationStatus: 'All', JobOfferingID: '', AgeFrom: '', AgeTo: '', Status: '',
                    Name: '', AggregateTypeID: '', DisplayPicture: false, DateFrom: '', DateTo: '', ExperienceType: 'Omit', Months: 0,
                    Years: 0, JobCampaignID: '',
                },
                applicants: [],
                aggregate: [],
                Types: 1,
                exceldata: [],
                exceldatastatus: 'default',
                delete: { id: '', ind: '' },
                showImage: false,
            }
        },

        created: function () {
        },

        mounted: function () {
            this.pageLoad();
        },

        updated: function () {
            if (this.applicants.length != 0) {
                $('#bs4-table').DataTable();
            }
        },

        methods: { 
            exportexcel() { 
                var vm = this;
                startReq();
                if (vm.Types != "1") {
                    toastr.error("Please select Posted Type to Download Excel Data", "Error!");
                    endReq();
                }
                else {
                  axios.post('/JobApplicationsApi/getexceldataofprospectus', {
                        filter: vm.filter,
                        type: 0,
                          })
                        .then(function (res) {
                            vm.exceldata = res.data.dataSet;
                            const xls = new XlsExport(vm.exceldata, 'Worksheet');
                            xls.exportToXLS('Job-Applicant.xls');
                            endReq();
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                }

            },

            pageLoad: function () {
                var vm = this;
                startReq();

                axios.post('/JobApplicationsApi/pageLoadRecivedApplications')
                    .then(function (pl) {
                        endReq();
                        vm.jobCampaigns = pl.data.jobCampaigns;
                        vm.gender = pl.data.gender;
                        vm.city = pl.data.city;
                         
                        vm.aggregate = pl.data.aggregate;
                    })
            },

            loadJobsOffered() {
                var vm = this;
                startReq();
                axios.post('/JobApplicationsApi/loadJobsOffered?id=' + vm.filter.JobCampaignID)
                    .then(function (pl) {
                        endReq(); 
                        vm.jobsOffered = pl.data.jobOffer;
                        vm.filter.JobOfferingID = '';
                    })
            },

            edit(id) {
                var vm = this;

                startReq();
                axios.post('/JobApplicationsApi/EditApplicationAdmin?ID=' + id)
                    .then(function (res) {
                        endReq();
                        if (res.data.status)
                            window.open("../Jobs/EditJobApplication?id=" + id, '_blank');
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            btnSearch() {

                

              var vm = this;
              if (vm.filter.AgeFrom > vm.filter.AgeTo) {
                toastr.error("Age to cannot be lesser than Age from");
                return;
              }
              startReq();
                axios.post('/JobApplicationsApi/searchJobApplicants', {
                    filter: vm.filter,
                })
                    .then(function (res) {
                        vm.showImage = vm.filter.DisplayPicture;
                        var table = $('#bs4-table').DataTable();
                        table.destroy();
                        vm.applicants = res.data;
                        vm.exceldatastatus = "enabled";

                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
             
             

            printCV(id) {
                var vm = this;
                startReq();
                axios.post('/ApplicantsApi/printCVForm?ID=' + id)
                    .then(function (res) {
                        endReq();
                        window.open(res.data.url, '_blank');
                        //redirect_blank(res.data.url);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            saveDeleteID(id, ind) {
                $('#mdlConfirm').modal('show');
                this.delete.id = id;
                this.delete.ind = ind;
            },

            followup(ID) {
                var vm = this;
                startReq();
                window.open("/Jobs/ApplicantFollowUps?ID=" + ID, '_blank');
                endReq();
            }

        }



    })</script>

<style>
    table thead tr th {
        background-color: #605ca8;
        color: white;
    }

    blink {
        -webkit-animation: 2s linear infinite condemned_blink_effect;
    }

    @-webkit-keyframes condemned_blink_effect {

        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }

    @keyframes condemned_blink_effect {
        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/RecivedJobApplications.vue